import React from 'react';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Button, MenuItem, Tooltip, Typography } from '@mui/material';

import { hasFreeSubscription, hasSubscriptionManagerPermission } from '@paragon/login-tools';

import { showUpgradeAccountDialog } from '../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../hooks';

export function UsageMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const dispatch = useAppDispatch();
  const usageData = useAppSelector((state) => state.usageData);
  const isFreeUser = useAppSelector(hasFreeSubscription);
  const isSubscriptionManager = useAppSelector(hasSubscriptionManagerPermission);

  return (
    <MenuItem>
      <DataUsageIcon sx={{ mr: 1 }} />
      Usage
      {usageData && (
        <Typography variant="body2" sx={{ ml: 1, verticalAlign: 'middle', color: 'text.secondary' }}>
          {`${usageData.usageThisMonth} / ${usageData.quotaPerMonth ?? '∞'}`}
        </Typography>
      )}
      <Tooltip title="Analyzing a truss which has not been analyzed before makes it count towards your usage">
        <HelpIcon sx={{ ml: 1 }} />
      </Tooltip>
      {isFreeUser && isSubscriptionManager && (
        <Button
          size="small"
          sx={{ ml: 1 }}
          variant="contained"
          onClick={() => {
            dispatch(showUpgradeAccountDialog());
            closeMenu();
          }}
        >
          Upgrade
        </Button>
      )}
    </MenuItem>
  );
}
